import { get, post } from '../utils/http';
import config from '../config.js';
/**
 * @returns 
 */
export function getCompanyDetails() {
  return get(`/api/companies/details/${config.companyId}`)
}
/**
 * 获取公司列表
 * @param {*} params 
 * pageIndex
 * pageSize
 * keyword
 */
export function getTenantList(params) {
  return get('/api/tenant', params)
}
/**
 * 获取简洁版公司列表
 * @param {*} params 
 * pageIndex
 * pageSize
 * keyword
 */
export function getSimpleTenantList(params) {
  return get('/api/tenant/simple', params);
}
/**
 * 获取aws 上传参数
 */
export function getAwsToken() {
  return get('/api/auth/awsClient/access')
}

/**
 * 获取公司的机构列表
 * @param {*} params 
 * pageIndex
 * pageSize
 * searchTenant 公司
 */
 export function getOrganizations(params) {
  return get('/api/lossAss/organizitions/simple', params);
}
/**
 * 获取角色列表
 * @param {*} params 
 * orgAccount 机构id
 */
export function getRoleList() {
  return get('/api/sysRole');
}

/**
 * 获取授权的临时 code
 * @param {*} params 
 * appId support：X2573I9Q5E；
 * redirectUrl 
 * @returns 
 * location 返回跳转的地址
 * state
 */
export function getAuth(params) {
  return post('/api/oauth/authorizecode', params)
}
/**
 * 获取 风控系统 客户端临时授权信息
 */
export function getRiskToken() {
  return get('/api/auth/riskSysmClient/access');
}
/**
 * 获取5g通话token
 */
export function getCallToken() {
  return get('/api/auth/5gCall/access');
}
/**
 * 图片上传
 * @param {*} params 
 * image 
 * flowId
 * type B端类型（小程序C 端不传）
 * address
 * picType
 * carNumber
 * lossId  定损信息id ，loss._id（不传lossId，图片默认放在标的下）
 * label
 * subLabel
 */
export function uploadPic(params) {
  return post('/api/lossAss/shotPics', params)
}
/**
 * 坐席端留言
 * @param {*} params 
 * flowId
 * message
 * agentName
 * file
 */
export function leaveMessage(params, headers = {}) {
  return post('/api/lossAss/report/agent/leaveMessage', params, headers);
}